import { render, staticRenderFns } from "./playerprofile.vue?vue&type=template&id=4ff92274&scoped=true"
import script from "./playerprofile.vue?vue&type=script&lang=js"
export * from "./playerprofile.vue?vue&type=script&lang=js"
import style0 from "./playerprofile.vue?vue&type=style&index=0&id=4ff92274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff92274",
  null
  
)

export default component.exports